export * from "./item-artifacts.component";
